import { getDataMapper, mapField } from "@/shared";

function CategoriesMeta() {
    this.id = mapField("id", Number);
    this.title = mapField("text");
    this.sum_deposit = mapField("cashDeposit", Number);
    this.discounts = mapField("discounts", Number);
    this.prices = mapField("tariffs", Number);
    this.children = mapField("children", this);
}

export const mapCategoriesToServer = getDataMapper({
    add: mapField("add", new CategoriesMeta()),
    delete: mapField("delete", Number),
});
